import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { io } from 'socket.io-client';
import { getCategories } from '../../api/analysis';
import { REACT_BASE_URL } from '../../api/Apis';
import { getSetting } from '../../api/Services';
import { TextCatContext } from './TextCatCotext';

function ContextCat(props) {
  useEffect(() => {
    handleGetCategories();
  }, []);

  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const handleGetCategories = async () => {
    try {
      const { data } = await getCategories();
      const CategoryList = data.result.map((item) => ({
        label: item,
        value: item,
      }));

      const AllCategoryList = [
        { label: 'ALL', value: 'ALL' },
        ...data.result.map((item) => ({
          label: item,
          value: item,
        })),
      ];
      setCategories(CategoryList);
      setAllCategories(AllCategoryList);
    } catch (err) {
      console.log(err);
    }
  };
  // ***************************
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [navbarArray, setNavbarArray] = useState([]);
  const [alarmSocket, setAlarmSocket] = useState([]);
  const [closeAlarm, setCloseAlarm] = useState([]);
  const [alarmHappenSocket, setAlarmHappenSocket] = useState([]);
  const [socketCount, setSocketCount] = useState(0);
  const [playAlarm, setPlayAlarm] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const alarmObject = {};
    const socketIoEmergency = io(`${REACT_BASE_URL}/emergency-alarms`);

    socketIoEmergency.on('resolve_emergency_alarm', (resolved) => {
      delete alarmObject[resolved.ID];
      updateData(alarmObject);
    });

    socketIoEmergency.emit('emergency_alarm', { alarms: 'all' });
    socketIoEmergency.on('emergency_alarm', (data) => {
      if (Object.keys(data).length !== 0) {
        alarmObject[data.ID] = data;
      }
      updateData(alarmObject);

      for (const key in alarmObject) {
        if (alarmObject[key]?.Sound) {
          setPlayAlarm(true);
          break;
        }
      }
      setTimeout(() => {
        const alarmArray = Object.values(alarmObject); // Convert object to array

        const activeAlarms = alarmArray.filter(
          (alarm) => alarm?.ClosedDate == null && alarm?.Category !== 'EVENT',
        );

        if (activeAlarms.length > 0) {
          setIsErrorModalVisible(true);

          setAlarmHappenSocket(activeAlarms); // Set all matching alarms
        }
      }, 1000);
    });

    return () => {
      socketIoEmergency.disconnect();
    };
  }, []);

  const updateData = async (obj) => {
    const info = await Promise.all(
      Object.values(obj).map(async (item) => ({ ...item })),
    );
    // console.log(info);
    setSocketCount(
      info?.filter((alarm) => alarm?.Category !== 'EVENT')?.length,
    );
    setAlarmSocket(info);
  };
  const [setting, setSetting] = useState();
  const handleGetSettingData = async () => {
    try {
      const { data } = await getSetting();
      setSetting(data.result[0]);
    } catch (ex) {
      console.log(ex);
    }
  };
  return (
    <TextCatContext.Provider
      value={{
        categories,
        allCategories,
        handleGetSettingData,
        setting,
        // ***************************
        isModalVisible,
        setIsModalVisible,
        isErrorModalVisible,
        setIsErrorModalVisible,
        navbarArray,
        setNavbarArray,
        alarmSocket,
        setAlarmSocket,
        closeAlarm,
        setCloseAlarm,
        alarmHappenSocket,
        setAlarmHappenSocket,
        socketCount,
        setSocketCount,
        playAlarm,
        setPlayAlarm,
      }}
    >
      {props.children}
    </TextCatContext.Provider>
  );
}

export default ContextCat;
